// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/header/LanguagePicker.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/header/LanguagePicker.tsx");
  import.meta.hot.lastModified = "1750073503846.9897";
}
// REMIX HMR END

import { useTranslation } from 'react-i18next';
import { useFetcher, useLocation } from '@remix-run/react';
import { classNames } from '~/utils/class-names';
const languages = [{
  code: 'cs',
  name: 'Čeština',
  flag: '🇨🇿'
}, {
  code: 'en',
  name: 'English',
  flag: '🇬🇧'
}];
export function LanguagePicker() {
  _s();
  const {
    i18n
  } = useTranslation();
  const fetcher = useFetcher();
  const location = useLocation();
  const isHomepage = location.pathname === '/' || location.pathname === '/o-nas' || location.pathname === '/about-us';
  const handleLanguageChange = async language => {
    // First change the UI language
    await i18n.changeLanguage(language);

    // Then update the server-side session
    fetcher.submit({
      language
    }, {
      method: 'post',
      action: '/api/language'
    });
  };
  return <div className="flex gap-2">
      {languages.map(language => <button key={language.code} onClick={() => handleLanguageChange(language.code)} className={classNames(i18n.language === language.code ? 'bg-gold2 border-gold2' : isHomepage ? 'border-gray-400 backdrop-blur-md' : 'border-gold2', 'size-12 border flex items-center justify-center p-2 rounded-md transition-all duration-200 hover:bg-gold2')} title={language.name} style={isHomepage && i18n.language !== language.code ? {
      background: `
                              linear-gradient(0deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.04) 100%),
                              rgba(255, 255, 255, 0.10)
                            `
    } : undefined}>
          <span className="text-lg">{language.flag}</span>
        </button>)}
    </div>;
}
_s(LanguagePicker, "3BR29q437o3aauZ6u4IViDnZqOU=", false, function () {
  return [useTranslation, useFetcher, useLocation];
});
_c = LanguagePicker;
var _c;
$RefreshReg$(_c, "LanguagePicker");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;